//NPM Packages
import { React } from "react";
import styled from "styled-components";

const FormBody = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

export default function LamininError(props) {
  return (
    <FormBody>
      Your information was not received, we apologise for the inconvenience.
      Please contact us on {props.phone}.
    </FormBody>
  );
}
